export type PageTableKeyboardController = {
  move: (delta: 1 | -1) => void;
  selectFirst: () => void;
  open: () => boolean;
  preview: () => boolean;
};

const controllers = new Map<symbol, PageTableKeyboardController>();

export function registerPageTableKeyboard(controller: PageTableKeyboardController): () => void {
  const id = Symbol("page-table-keyboard");
  controllers.set(id, controller);
  return () => {
    controllers.delete(id);
  };
}

export function getSolePageTableKeyboard(): PageTableKeyboardController | null {
  if (controllers.size !== 1) return null;
  return controllers.values().next().value ?? null;
}

export function resetPageTableKeyboardRegistryForTests() {
  controllers.clear();
}

export function pageTableKeyboardRegistrationCountForTests() {
  return controllers.size;
}
